import Skeleton from 'react-loading-skeleton';

const LayoutSkeleton = () => {
  return (
    <div>
      <div className="w-[200px] lg:w-[400px]">
        <Skeleton
          baseColor="#E0E0E0"
          width={'100%'}
          height={16}
          borderRadius={8}
        />
      </div>
      <div className="w-[100px] lg:w-[200px]">
        <Skeleton
          baseColor="#E0E0E0"
          width={'100%'}
          height={16}
          borderRadius={8}
        />
      </div>
    </div>
  );
};

export default LayoutSkeleton;
